import { useAvailablePeriods } from '@entities/available-periods';
import { useSchedules, useTz } from '@entities/schedules';
import cn from 'classnames';
import { memo } from 'react';
import {
  AvailableEditorIcon,
  AvailableEditorSession, EmptyEditorSession,
  Session,
  useSession,
} from '@features/shedules/index.ts';
import { AvailableSession } from '../available-session';
import { BusySession } from '../busy-session';
import { EmptySession } from '../empty-session';
import * as st from './styles.module.scss';
import { doRenderEmptySession } from '@entities/schedules/schedule/helpers.tsx';

interface SessionProps {
  start: Date;
  end: Date;
  onScheduleClick?: (id: number) => void;
  onAvailableClick?: (id: number) => void;
  className?: string;
}

export const SessionBlockOld: React.FC<SessionProps> = memo(
  ({ start, end, onScheduleClick, className, onAvailableClick }) => {
    const { findSchedules } = useSchedules();
    const { findAvailable } = useAvailablePeriods();
    const { tz } = useTz();

    const availablePeriod = findAvailable({ start, end }, tz);
    const busyPeriod = findSchedules({ start, end }, tz);

    const onClick = () => {
      if (busyPeriod && onScheduleClick) onScheduleClick(busyPeriod.consultation_id);
      if (!busyPeriod && availablePeriod && onAvailableClick) onAvailableClick(availablePeriod.id);
    };

    return (
      <div className={cn(st.calendar__session, className)}>
        {availablePeriod && !busyPeriod && (
          <AvailableSession
            start={start}
            end={end}
            availableId={availablePeriod.id}
            onClick={onClick}
          />
        )}

        {busyPeriod && (
          <BusySession start={start} end={end} scheduleId={busyPeriod.id} onClick={onClick} />
        )}

        {!availablePeriod && !busyPeriod && <EmptySession start={start} end={end} />}
      </div>
    );
  }
);
const steps = [0, 1, 2];
export const SessionBlock: React.FC<SessionProps> = memo(
  ({ className, start, end, onScheduleClick, onAvailableClick }) => {
    // const { findSchedules } = useSchedules();
    // const { findAvailable } = useAvailablePeriods();
    const { findAvailable, findBusy } = useSession();
    const session = {start, end};
    const { tz } = useTz();


    const busyPeriod = findBusy({ start, end });

    const { firstAvailablePeriod, secondAvailablePeriod } = findAvailable(session);
    const isSamePeriod = firstAvailablePeriod?.id === secondAvailablePeriod?.id;

    const onClick = () => {
      if (busyPeriod && onScheduleClick) onScheduleClick(busyPeriod.consultation_id);
      if (!busyPeriod && firstAvailablePeriod && onAvailableClick) onAvailableClick(firstAvailablePeriod.id);
    };

    return (
      <Session>
        <>
          {firstAvailablePeriod?.id && !busyPeriod && (
            <AvailableEditorSession
              session={session}
              availablePeriod={firstAvailablePeriod}
              // isActive={term?.id === firstAvailablePeriod?.terms[0]?.id}
              hasOneMorePeriod
              // onClick={() => onAvailableClick(firstAvailablePeriod)}
              // onMouseOver={(e) => onAvailableHover(e, firstAvailablePeriod, session)}
              // onMouseLeave={() => hide()}
              // emptySessionHandlers={emptySessionHandlers}
            />
          )}
          {secondAvailablePeriod?.id && !isSamePeriod && !busyPeriod && (
            <AvailableEditorSession
              session={session}
              availablePeriod={secondAvailablePeriod}
              // isActive={term?.id === secondAvailablePeriod?.terms[0]?.id}
              // onClick={() => onAvailableClick(secondAvailablePeriod)}
              // onMouseOver={(e) => onAvailableHover(e, secondAvailablePeriod, session)}
              // onMouseLeave={() => hide()}
              // emptySessionHandlers={emptySessionHandlers}
            />
          )}
        </>
        {/*{busyPeriod && (*/}
        {/*  <BusySession start={start} end={end} scheduleId={busyPeriod.id} onClick={onClick} />*/}
        {/*)}*/}

        {/*{!firstAvailablePeriod &&*/}
        {/*  !busyPeriod &&*/}
        {/*  // doRenderEmptySession(emptySessionHandlers)}*/}
      </Session>
    );
  }
);
